<template>
    <div>
        <q-score-card key="QScoreCardAverageAppsPerAgent" ref="card" title="Average Apps Per Agent" api-endpoint="average_apps_per_agent" :drill-down-label="null" :drill-down-route="null" card-style="recruiting" :agent-code="agentCode" :filters="filters" v-on:most_current="updateMostCurrent">
            Note: This is a rolling 6 month average number of apps per agent.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardAverageAppsPerAgent",
    props: ["agentCode", "filters"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {},
    computed: {

    },
    methods: {
        updateMostCurrent: function(most_current) {
            this.$emit('most_current', most_current);
        }
    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
